angular.module('bmsApp.crm.prospect').controller('ProspectSaveCtrl', function ($state,
																			   $scope,
																			   $q,
																			   $timeout,
																			   notify,
																			   ProspectStageSvc,
																			   ProspectStatusSvc,
																			   ContactSvc,
																			   ProspectSvc,
																			   NoteSvc) {

	$scope.init = function () {
		$scope.loading = true;
		$scope.processing = false;
		$scope.noteCtrl = {
			note: {},
			noteApi: {}
		};
		$scope.action = $state.current.name == 'main.crm.prospect.index.view.update' ? 'updating' : 'creating';
		$scope.prospect = {
			weighting: 0,
			forecast_value: 0
		};
		$scope.note = {};
		var contactId = $state.params.contactId ? parseInt($state.params.contactId) : null;
		if (contactId) {
			angular.extend($scope.prospect, {
				contact: {
					id: contactId
				}
			});
		}
		var promises = {
			prospectStageOptions: ProspectStageSvc.options(),
			prospectStatusOptions: ProspectStatusSvc.options(),
			contactOptions: ContactSvc.primaryOptions(),
			noteTypeOptions: NoteSvc.noteTypeOptions()
		};
		if ($scope.action === 'updating') {
			promises.prospectRead = ProspectSvc.read($state.params.prospectId);
		}
		$q.all(promises)
			.then(function (responses) {
				$scope.prospectStageOptions = responses.prospectStageOptions.data.options;
				$scope.prospectStatusOptions = responses.prospectStatusOptions.data.options;
				$scope.contactOptions = responses.contactOptions.data.options;
				$scope.noteTypeOptions = responses.noteTypeOptions.data.options;
				if (angular.isDefined(responses.prospectRead)) {
					angular.extend($scope.prospect, responses.prospectRead.data.prospect);
				}
				$scope.loading = false;
			});
	};

	$scope.prospectFormat = function (value) {
		return value + '%';
	};

	$scope.formvalidatorconfig = {
		submitHandler: function () {
			// join the note to the prospect if it was filled in
			if (angular.isObject($scope.noteCtrl.noteApi) && $scope.noteCtrl.noteApi.isNoteFilled() === true) {
				if (!$scope.noteCtrl.noteApi.submittable) {
					return;
				}
				angular.extend($scope.prospect, {
					note: angular.copy($scope.noteCtrl.note)
				});
			}
			$scope.processing = true;
			var savePromise = $scope.action === 'updating' ? ProspectSvc.update($scope.prospect.id, $scope.prospect) : ProspectSvc.create($scope.prospect);

			savePromise
				.then(function (response) {
					notify({
						message: $scope.action == 'updating' ? 'Prospect saved successfully' : 'Prospect created successfully'
					});
					$state.go('main.crm.prospect.index');
				}, function (error) {
					$scope.errors = error;
				})
				.finally(function () {
					$scope.processing = false;
				});
		},
		errorPlacement: function (error) {
			error.appendTo('#prospect-errors');
		},
		errorContainer: '#prospect-errors'
	};

	$scope.init();

});